import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 24px 28px 12px;
  background: #fff;
  border-radius: 20px;
  border: 1px solid #F1F2F6;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 12px 24px -12px rgba(16, 24, 40, 0.08);
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 8px;
`;

export const Eyebrow = styled.span`
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8B90A0;
  margin-bottom: 6px;
`;

export const TotalValue = styled.span`
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: #1F2333;
  letter-spacing: -0.02em;
`;

export const RangeCaption = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 0.78rem;
  font-weight: 500;
  color: #8B90A0;
`;

export const Stats = styled.div`
  display: flex;
  gap: 24px;

  .stat {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
  }

  .label {
    font-size: 0.72rem;
    font-weight: 600;
    color: #9CA3AF;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  .value {
    font-size: 0.95rem;
    font-weight: 700;
    color: #4F46E5;
    text-transform: capitalize;
  }
`;

export const UpdatingBadge = styled.div`
  position: absolute;
  top: 24px;
  right: 28px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #4F46E5;
  background: #EEF2FF;
  padding: 4px 10px;
  border-radius: 999px;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #4F46E5;
    animation: pulse 1.2s ease-in-out infinite;
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.35; }
  }
`;

export const ChartArea = styled.div`
  margin-top: 12px;
  margin-left: -8px;
`;

export const TooltipCard = styled.div`
  background: #1F2333;
  color: #fff;
  border-radius: 10px;
  padding: 10px 14px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.25);
  display: flex;
  flex-direction: column;
  gap: 2px;

  .period {
    font-size: 0.72rem;
    font-weight: 600;
    color: #B4B8C5;
    text-transform: capitalize;
  }

  .value {
    font-size: 0.95rem;
    font-weight: 700;
  }
`;

export const NotData = styled.div`
  color: #9CA3AF;
  font-weight: 600;
  height: 220px;
  width: 100%;
  font-size: 0.9rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
